import type { ListsState } from '@pancakeswap/token-lists/react'
import { atom, useSetAtom } from 'jotai'
import { useEffect } from 'react'

/**
 * Site review 59 #6 (2026-10-08): the inactive token lists (cmc 2.5 MB, coingecko 816 KB raw) serve one thing, the picker's search
 * for a token outside the active lists. They used to be fetched on every cold load of every page; now the picker raises this flag
 * when a search is typed and the Updater fetches them once. The active lists are still fetched on load, exactly as before.
 */
export const inactiveListsWantedAtom = atom(false)

/** Called by the picker's search: once `wanted` is true the inactive lists are fetched (the flag never goes back). */
export function useWantInactiveLists(wanted: boolean) {
  const set = useSetAtom(inactiveListsWantedAtom)
  useEffect(() => {
    if (wanted) set(true)
  }, [wanted, set])
}

/** The lists to fetch now: not loaded, not loading, not failed; the active ones always, the inactive ones only once a search asked. */
export function listsToFetch(lists: ListsState['byUrl'], activeUrls: readonly string[], wantInactive: boolean): string[] {
  return Object.keys(lists).filter((url) => {
    const list = lists[url]
    if (!list || list.current || list.loadingRequestId || list.error) return false
    return wantInactive || activeUrls.includes(url)
  })
}
